import { combineReducers } from "redux";
import userReducer from "./user";
import PaymentsReducer from "./payment";

export default combineReducers({
  userReducer,
  PaymentsReducer,
});
